module.exports = __webpack_public_path__ + "dimer/static/img/1.dfb6b50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/1.jpg
// module id = 4FbQ
// module chunks = 0